export const planControllers = {
  RADIO: 'radio',
  COUNTER: 'counter',
  DROPDOWN: 'dropdown',
  NONE: 'none',
};

export type planControllerTypes =
  typeof planControllers[keyof typeof planControllers];
